<template>
  <main :id="$style.main">
    <main-home-visual />
    <about-home-visual />
    <customer-home-visual />
    <hideki-info-home-visual />
    <shop-home-visual />
    <present-home-visual />
    <banner-home-visual />
  </main>
</template>

<script lang="ts">
import Vue from "vue";
import MainHomeVisual from "@/components/organsms/home/MainHomeVisual.vue";
import AboutHomeVisual from "@/components/organsms/home/AboutHomeVisual.vue";
import CustomerHomeVisual from "@/components/organsms/home/CustomerHomeVisual.vue";
import HidekiInfoHomeVisual from "@/components/organsms/home/HidekiInfoHomeVisual.vue";
import ShopHomeVisual from "@/components/organsms/home/ShopHomeVisual.vue";
//import BannerHomeVisual from '@/components/organsms/home/BannerHomeVisual' //能美市のイベントの際に一時的に表示していたもの

export default Vue.extend({
  name: "HomeView",

  components: {
    MainHomeVisual,
    AboutHomeVisual,
    CustomerHomeVisual,
    HidekiInfoHomeVisual,
    ShopHomeVisual,
    //BannerHomeVisual
  }
});
</script>

<style lang="scss" module>
@import "../../assets/style/base.scss";

@media only screen and (max-width: 1023px) {
  #main {
    padding: 0;
    overflow: hidden;
    width: 100%;
  }
}
@media only screen and (min-width: 1024px) {
  #main {
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
}
</style>
